import React from 'react'
import { FiX } from 'react-icons/fi'

export default function CloseButton({ closeToast }: ICloseButtonDispatch) {
  return (
    <FiX
      size={20}
      color={'#fff'}
      onClick={closeToast}
      style={{ margin: 'auto' }}
    />
  )
}

export interface ICloseButtonDispatch {
  closeToast?: () => void
}
